import Badge from 'src/components/Badge';
import { SiteDeviceNodeStatus } from '../../types';

type StatusMapItem = {
  color?: 'success' | 'info' | 'error' | 'warning';
  label: string;
};

type Props = {
  value?: SiteDeviceNodeStatus;
};

function NodeItemStatus({ value }: Props) {
  const statusMap: Record<SiteDeviceNodeStatus, StatusMapItem> = {
    [SiteDeviceNodeStatus.Ready]: { color: 'success', label: 'Ready' },
    [SiteDeviceNodeStatus.Unavailable]: {
      color: 'warning',
      label: 'UNAVAILABLE',
    },
  };

  const statusItem =
    value && statusMap[value]
      ? statusMap[value]
      : statusMap[SiteDeviceNodeStatus.Unavailable];

  return (
    <>
      <Badge {...statusItem} />
    </>
  );
}

export default NodeItemStatus;
